import React from "react";
import useUser from "@hooks/useUser";
import css from "./UserSection.module.scss";
import { getAsset } from "@helper/getConfigValues";
import { InboxIcon } from "@assets/icons";

export interface UserSectionProps {
    redirectAnchor?: string;
}

export default function UserSection({ redirectAnchor }: UserSectionProps) {
    const { user, isLoading, isSignedIn } = useUser();
    if (isLoading) {
        return null;
    }

    let loginUrl = "/login";
    if(!isSignedIn) {
        const redirect = new URLSearchParams({returnUrl: document.location.pathname}).toString();
        loginUrl = `/login?${redirect}${redirectAnchor ? `%23${redirectAnchor}` : ''}`;
    }
    return (
        <div>
            {isSignedIn
                ? <>
                    <div className={css.loggedIn}>
                        <div>You are signed as {user.name}</div>
                        <a href="/logout" data-testid="enquiry-form-logout">Log out</a>
                    </div>
                </>
                : <>
                <div className={css.login}>
                    <a href={loginUrl} data-testid="enquiry-form-login">Sign in</a>
                    <a href={loginUrl} data-testid="enquiry-form-login-google"><img src={getAsset('icons/login/google-logo.png')} className={css.googleLogo} /></a>
                    <a href={loginUrl} data-testid="enquiry-form-login-fb"><img src={getAsset('icons/login/facebook-logo.png')} className={css.facebookLogo}/></a>
                    <a href={loginUrl} data-testid="enquiry-form-login-email"><InboxIcon /></a>
                </div>
                    <div className={css.divider}>
                        <div>or enter contact details below</div>
                    </div>
                </>}
        </div>
    );
}
